import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex","align-items":"center","column-gap":"30px"} }

import { ref, reactive, computed } from "vue";
import type { FormInstance, FormRules } from "element-plus";
interface RuleForm {
  authType: string;
  authName?: string;
  authCard?: string;
  projectName?: string;
  projectRemark?: string;
}
interface FromData {
  modelValue: RuleForm;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'purchasedMaterial-accredit',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "close", "submit"],
  setup(__props: any, { emit: __emit }) {

const formSize = ref("default");
const emit = __emit;
const ruleFormRef = ref<FormInstance>();
const props = __props;

const form = computed({
  get() {
    console.info(props.modelValue);
    if (props.modelValue) return props.modelValue;
    else
      return {
        authType: "SELF",
      };
  },
  set(v) {
    emit("update:modelValue", v);
  },
});
const rules = reactive<FormRules<RuleForm>>({
  authName: [{ required: true, message: "请输入内容", trigger: "blur" }],
  authCard: [{ required: true, message: "请输入内容", trigger: "blur" }],
  projectName: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
  projectRemark: [
    { required: true, message: "请输入项目简介", trigger: "blur" },
  ],
});
const onSubmit = () => {
  emit("submit");
};
const onCancel = () => {
  emit("close");
};

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: form.value,
      "label-width": "100px",
      rules: rules,
      class: "demo-ruleForm",
      size: formSize.value,
      "status-icon": "",
      "label-position": "left"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "授权主体",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_group, {
              modelValue: form.value.authType,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.authType) = $event)),
              disabled: "",
              class: "ml-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  label: "SELF",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("个人")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "ENTERPRISE",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("公司")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_radio, {
                  label: "UNION",
                  size: "large"
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("联盟")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "line" }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { style: {"margin-bottom":"0.2rem"} }, [
          _createElementVNode("span", null, "主体信息"),
          _createElementVNode("span", { style: {"color":"#86909c"} }, "（注：请填写最终使用客户全称。如果你是乙方个人或公司，请填写甲方客户全称）")
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form_item, {
            label: form.value.authType == 'SELF' ? '联系人姓名' : '客户名称',
            prop: "authName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.authName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.authName) = $event)),
                placeholder: form.value.authType == 'SELF' ? '请输入联系人姓名' : '请输入客户名称'
            
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: form.value.authType == 'SELF' ? '身份证号' : '组织代码',
            prop: "authCard"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: form.value.authCard,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.authCard) = $event)),
                placeholder: form.value.authType == 'SELF'
              ? '请输入身份证号'
              : '请输入统一社会信用代码'
            
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "line" }, null, -1)),
        _cache[11] || (_cache[11] = _createElementVNode("div", { style: {"margin-bottom":"0.2rem"} }, [
          _createElementVNode("span", null, "项目信息"),
          _createElementVNode("span", { style: {"color":"#86909c"} }, "（注：请填写商品被应用的项目信息）")
        ], -1)),
        _createVNode(_component_el_form_item, {
          label: "项目名称",
          prop: "projectName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: form.value.projectName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.projectName) = $event)),
              placeholder: "请输入项目名称"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "项目简介",
          prop: "projectRemark"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: form.value.projectRemark,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.projectRemark) = $event)),
              placeholder: "请输入项目简介"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _cache[12] || (_cache[12] = _createElementVNode("div", null, " 你填写的信息将呈现在授权书上，具有法律效力，确认后无法修改，请认真填写。 ", -1))
      ]),
      _: 1
    }, 8, ["model", "rules", "size"]),
    _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
      _createElementVNode("div", {
        class: "dataBtnClose",
        onClick: onCancel
      }, "取消"),
      _createElementVNode("div", {
        class: "dataBtnSubmit",
        onClick: onSubmit
      }, "确认")
    ])
  ]))
}
}

})